import useBreakpoints from "neetocommons/react-utils/useBreakpoints";
import { Book, ChatQuestions, Community, Status } from "neetoicons";
import { Dropdown as NeetoUIDropdown } from "neetoui";
import { toLower } from "ramda";
import { useTranslation } from "react-i18next";

import MenuButton from "./MenuButton";

const { Menu, MenuItem } = NeetoUIDropdown;

const HelpMenu = () => {
  const { t } = useTranslation();
  const { isSize } = useBreakpoints();

  const isMobile = isSize("mobile");

  return (
    <NeetoUIDropdown
      closeOnSelect={false}
      customTarget={<MenuButton />}
      interactiveDebounce={30}
      offset={[0, 5]}
      position={isMobile ? "bottom" : "right"}
      trigger="all"
      zIndex={99999}
    >
      <Menu>
        <MenuItem.Button
          className="neeto-molecules-menu-sublist__item-btn"
          data-testid="help-link-help-articles-button"
          href={`https://help.${toLower(globalProps.appName)}.com/`}
          prefix={<Book size={18} />}
          rel="noreferrer"
          target="_blank"
        >
          {t("neetoMolecules.sidebar.helpLinks.helpArticles")}
        </MenuItem.Button>
        <MenuItem.Button
          className="neeto-molecules-menu-sublist__item-btn"
          data-testid="help-link-live-chat-button"
          prefix={<ChatQuestions size={18} />}
          onClick={() => {
            window.NeetoChat?.contextualHelp?.maximizeWidget();
            window.NeetoChat?.contextualHelp?.openWidget();
          }}
        >
          {t("neetoMolecules.sidebar.helpLinks.liveChat")}
        </MenuItem.Button>
        <MenuItem.Button
          className="neeto-molecules-menu-sublist__item-btn"
          data-testid="help-link-community-button"
          href="https://www.launchpass.com/neetohq"
          prefix={<Community size={18} />}
          rel="noreferrer"
          target="_blank"
        >
          {t("neetoMolecules.sidebar.helpLinks.askTheCommunity")}
        </MenuItem.Button>
        <MenuItem.Button
          className="neeto-molecules-menu-sublist__item-btn"
          data-testid="help-link-status-button"
          href="https://neetostatus.com/"
          prefix={<Status size={18} />}
          rel="noreferrer"
          target="_blank"
        >
          {t("neetoMolecules.sidebar.helpLinks.systemStatus")}
        </MenuItem.Button>
      </Menu>
    </NeetoUIDropdown>
  );
};

export default HelpMenu;
